import Swiper from 'swiper/js/swiper.js';
import 'mark.js/dist/jquery.mark.js';

export default {
  init() {
    // JavaScript to be fired on all pages
    $(document).ready( function() {

    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $(document).ready(function() {
      var headerHeight = $('header.banner').height();
      var footerHeight = $('footer').height();

      var altura = headerHeight + footerHeight;

      $('.bodyContent').css({'min-height':'calc( 100vh - '+ altura +'px )'});

      if($('.artigos-container').length){
        var swiper = new Swiper('.artigos-container', {
          observer: true,
          slidesPerView: 1,
          spaceBetween: 10,
          allowTouchMove: true,
          navigation: {
            nextEl: '.artigos-button-next',
            prevEl: '.artigos-button-prev',
          },
          pagination: {
            el: '.artigos-pagination',
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
              allowTouchMove: true,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 30,
              allowTouchMove: false,
            },
          },
        });
      }

      if($('.alternativa-container').length){
        new Swiper('.alternativa-container', {
          observer: true,
          slidesPerView: 1,
          spaceBetween: 10,
          allowTouchMove: true,
          setWrapperSize: true,
          autoHeight: true,
          // navigation: {
          //   nextEl: '.alternativa-container-button-next',
          //   prevEl: '.alternativa-container-button-prev',
          // },
          pagination: {
            el: '.alternativa-container-pagination',
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
              allowTouchMove: true,
            },
          },
        });
      }

      if($('.colaboradores-swiper').length) {
        new Swiper('.colaboradores-swiper', {
          observer: true,
          // slidesPerView: 'auto',
          slidesPerView: 2,
          spaceBetween: 30,
          allowTouchMove: true,
          // navigation: {
          //   nextEl: '.colaboradores-next',
          //   prevEl: '.colaboradores-prev',
          // },
        });

      }

      if($('.apoiadores-swiper').length) {
        new Swiper('.apoiadores-swiper', {
          observer: true,
          slidesPerView: 2,
          // slidesPerView: 'auto',
          spaceBetween: 30,
          allowTouchMove: true,
          // navigation: {
          //   nextEl: '.colaboradores-next',
          //   prevEl: '.colaboradores-prev',
          // },
        });
      }

       if($('.blocoextra-swiper').length) {
        new Swiper('.blocoextra-swiper', {
          observer: true,
          // slidesPerView: 'auto',
          slidesPerView: 2,
          spaceBetween: 30,
          allowTouchMove: true,
          // navigation: {
          //   nextEl: '.blocoextra-next',
          //   prevEl: '.blocoextra-prev',
          // },
        });
      }



      if($('.agradecimentos-container').length) {
        new Swiper('.agradecimentos-container', {
          observer: true,
          slidesPerView: 1,
          spaceBetween: 10,
          allowTouchMove: true,
          navigation: {
            nextEl: '.agradecimentos-next',
            prevEl: '.agradecimentos-prev',
          },
          // pagination: {
          //   el: '.agradecimentos-pagination',
          //   clickable: true,
          // },
          scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
              allowTouchMove: true,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 30,
              allowTouchMove: false,
            },
          },
        });
      }

      var $cards = $('.cards');

      if ( $cards.length){
        $('.card-link').hover(

          function(){
            $(this).closest('.card').css({'transform':'scale(1.03)'}).removeClass('shadowOut').addClass('shadowIn');
          },

          function(){
            $(this).closest('.card').css({'transform':'scale(1)'}).addClass('shadowOut').removeClass('shadowIn');
          }

        );
      }

      $(document).click(function(e) {
        // console.log(e.target);
        if($(e.target).is('.text.menu-title, .icon-seta-baixo-menu, .menu-icon, .menu-icon__hamburger, #menu-open')) {
          return;
        }
        if(!$('#menu').hasClass('closed')){
          $('#menu').addClass('closed');
          $('.menu-icon').removeClass('active');
        }
      });

      $('.menu-open').on('click', function(e){
        e.preventDefault();

        if($('#menu').hasClass('closed')){
          $('#menu').removeClass('closed');
          $('.menu-icon').addClass('active');
        } else{
          $('#menu').addClass('closed');
          $('.menu-icon').removeClass('active');
        }

      });

      // $('.ajuda').on('click', function(e){
      //   e.preventDefault();
      // });

      $('.busca').on('click', function(e){
        e.preventDefault();
      });

      $('.ver-todas').on('click', function(event) {
        event.preventDefault();

        var $cards = $('.h-0');
        var time = 0;

        $($cards).each(function() {
          var $card = $(this);

          setTimeout(function() {
            $card.css({'opacity':'1', 'top':'0'});
            $card.closest('.col').css({'position':'relative'});
          }, time);

          time += 50;
        });

        $(this).addClass('d-none');

      });

      if ($('a.ancora').length){
        $('a.ancora').on('click', function( event ) {
          event.preventDefault();

          $('html, body').animate({
             scrollTop: $($(this).attr('href')).offset().top,
          }, 500);
        });
      }

      // function alturaTitulo() {
      //   if ($('#artigos .titulo').length){
      //
      //     var highest = -Infinity;
      //     $('#artigos .titulo').each(function() {
      //       if($(this).hasClass('mostrar')){
      //         highest = Math.max(highest, $(this).height());
      //       }
      //     });
      //
      //     $('#artigos .titulo').height(highest);
      //   }
      // }
      //
      // alturaTitulo();

      if ($('table').length){
        $('table').addClass('table');
      }

      if ($('.card-body table').length){
        $('.card-body table').each(function(){
          $(this).wrap('<div class="table-card"></div>');
        });
      }

      if ($('.wp-block-table').length){
        $(this).find('table').addClass('table');
        $('.wp-block-table').addClass('table-card');
      }

      if($('td').length){
        $('td').removeAttr('width');
        $('table').removeAttr('width');
      }

      $('#filtro').change(function() {
        var selecao = $( this ).val();
        if(selecao=='all'){
          $('[data-filter]').css('display', 'flex').addClass('mostrar');
          $('[data-filter]').find('.titulo').addClass('mostrar');

          // alturaTitulo();
          swiper.updateSlides();
          swiper.updateProgress();
          swiper.updateSlidesClasses();
          swiper.slideTo(0);
        } else {
          $('.swiper-slide').not('[data-filter='+selecao+']').css('display', 'none');
          $('[data-filter='+selecao+']').css('display', 'flex');

          $('.swiper-slide').not('[data-filter='+selecao+']').find('.titulo').removeClass('mostrar');
          $('[data-filter='+selecao+']').find('.titulo').addClass('mostrar');

          // alturaTitulo();
          swiper.updateSlides();
          swiper.updateProgress();
          swiper.updateSlidesClasses();
          swiper.slideTo(0);
        }
      });

      if($('.seleciona-conteudo').length){
        $('.seleciona-conteudo').change(function(){
          var selecaoConteudo = $( this ).val();

          $('.box-content').css('display', 'none');
          $('.box-content.'+selecaoConteudo).css('display', 'block');
        });
      }

      function DropDown(el) {
          this.dd = el;
          this.placeholder = this.dd.children('span');
          this.opts = this.dd.find('ul.drop li');
          this.val = '';
          this.index = -1;
          this.initEvents();
      }

      DropDown.prototype = {
          initEvents: function () {
              var obj = this;
              obj.dd.on('click', function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  $(this).toggleClass('active');
              });
              obj.opts.on('click', function () {
                  var opt = $(this);
                  obj.val = opt.text();
                  obj.index = opt.index();
                  obj.placeholder.text(obj.val);
                  opt.siblings().removeClass('selected');
                  opt.filter(':contains("' + obj.val + '")').addClass('selected');
                  var filtrar = opt.closest('ul').data('filtrar');
                  var selecao = $(this).data('filtro');

                  // console.log(filtrar);
                  // console.log(selecao);

                  var target;
                  if(selecao == 'all') {
                    target = $('#'+filtrar).find('[data-filter]');

                    if ( target.is( 'tr' )) {
                      target.css('display', 'table-row');
                    }else{
                       target.css('display', 'flex');
                    }
                  }else {
                    target = $('#'+filtrar).find('[data-filter]');
                    target.css('display', 'none');
                     if ( target.is( 'tr' )) {
                      $('#'+filtrar).find('[data-filter*='+selecao+']').css('display', 'table-row');
                     }else{
                      $('#'+filtrar).find('[data-filter*='+selecao+']').css('display', 'flex');
                     }

                  }
              }).change();
          },
          getValue: function () {
              return this.val;
          },
          getIndex: function () {
              return this.index;
          },
      };

      new DropDown($('#filtro-artigos'));
      new DropDown($('#filtro-fintech'));
      new DropDown($('#filtro-bancos'));
      new DropDown($('#filtro-fundos'));
    });

    var cardOffset = 180;

    if ($(window).width() < 736) {
      cardOffset = 95;
    }

    $('.card').on('hide.bs.collapse', function () {
        var id = $(this).find('.card-header').attr('id');
        // console.log(id);
        $('html, body').animate({
            scrollTop: $('#'+id).offset().top - cardOffset,
        }, 150);
    });
    $('.card').on('shown.bs.collapse', function () {
        var id = $(this).find('.card-header').attr('id');
        // console.log(id);
        $('html, body').animate({
            scrollTop: $('#'+id).offset().top - cardOffset,
        }, 150);
    });

    /**
      * Highlights
      */


    /*Cookies*/
    function createCookie(name, value, days) {
      var expires;

      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = '; expires=' + date.toGMTString();
      } else {
          expires = '';
      }
      document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
    }

    function readCookie(name) {
      var nameEQ = encodeURIComponent(name) + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ')
              c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) === 0)
              return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return '';
    }

    //function eraseCookie(name) {
    //  createCookie(name, '', -1);
    //}

    //CF7
    $(document).ready(function() {
      /*guarda na variavel url o caminho o permalink da página de acordo com post-ID */
      var url = $('.site-data').data('url');

      /* verifica a existencia do cookie*/

      var cookie = readCookie('email');

      /*grava url atual*/
      var urlAtual = $(location).attr('href'),
          parts = urlAtual.split('/'),
          last_part = parts[parts.length-2];

      /* Se cookie não foi gravado e tentar acessar as páginas de conteudo ou processo para acessar será redidicionado para a página principal do conteudo*/
      if(last_part == 'processo-para-acessar' || last_part=='conteudo'){
        if(!cookie.length){
          window.location = url;
        }
      }

      /*guarda variavel com o elemento formulario*/
      var forms = document.getElementsByClassName('wpcf7-form');
      url += 'processo-para-acessar';
       
      /*marca checkbox ao abrir formulário*/
      if($('.receber-email').length){
        $('.receber-email').find('input[type="checkbox"]').prop('checked',true);
      }


      /*adiciona o atributo requerido em html caso exista a classe de validacao do wpcf7 (necessário para usar o validador do bootstrap)*/
      $('#passo-1 .wpcf7-validates-as-required').attr('required', true);
      $('#passo-2 .wpcf7-submit').attr('disabled', true);
      $('#passo-3 .wpcf7-submit').attr('disabled', true);

      $('#passo-2 input').on('change', function(){
          $('#passo-2 .wpcf7-submit').attr('disabled', false);
      });

      $('#passo-3 input').on('change', function(){
          $('#passo-3 .wpcf7-submit').attr('disabled', false);
      });
      /*grava opção selecionada*/
      var selecionado;
      $('#empresaForm').change(function(){
        selecionado = $(this).children('option:selected').val();
      });

      /*Controla passos do formulário*/
      $('.passo').on('click', function(e){
        e.preventDefault();
        Array.prototype.filter.call(forms, function(form) {
          if (form.checkValidity() !== false) {

            $('#passo-1').addClass('d-none');

            if(selecionado == 'Sim'){
              $('#passo-2').removeClass('d-none');
            }else {
              $('#passo-3').removeClass('d-none');
            }
          }
          form.classList.add('was-validated');
        });
      });


      $('.alternativa-data').on('click', function() {
          url = $(this).data('url');
      })

      /* Função para contagem de tempo e redirecionar a página*/
      function startTimer(duration, display) {
        var timer = duration, seconds;
        setInterval(function () {
          // minutes = parseInt(timer / 60, 10)
          seconds = parseInt(timer % 60, 10);

          // minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? '0' + seconds : seconds;

          display.text(seconds);

          if (--timer < 0) {
             /* vai para a página após rodar o tempo */
             window.location = url;
          }
        }, 1000);
      }

      /* Controla ações após enviar form*/
      document.addEventListener( 'wpcf7mailsent', function( ) {
        $('.formulario').css({'display': 'none'});
        $('.resposta').css({'display': 'block'});

        $(function ($) {
          /*Grava cookie*/
          createCookie('email', 'cadastrado', 365);

          /* Dispara contador*/
          var segundos = 3,
              display = $('#contador');
          startTimer(segundos, display);
        });
      }, false );
    });

    /*
     * Buscar na página
     */

    /*Grava variavel results fora da função para utiliza-la em outras funcões*/
    var $results ='';

    $(function() {

      var $input = $('#searchField'),

        // clear button
        $clearBtn = $('button[data-search="clear"]'),
        // prev button
        $prevBtn = $('button[data-search="prev"]'),

        // next button
        $nextBtn = $('button[data-search="next"]'),

        // the context where to search
        $content = $('.conteudoHighlight'),

        currentClass = 'current',


        // top offset for the jump (the search bar)
        offsetTop = 200,

        // the current index of the focused element
        currentIndex = 0;

        if ($(window).width() < 736) {
          offsetTop = 120;
        }

      /**
      * Jumps to the element matching the currentIndex
      */

      function jumpTo() {
        if ($results.length) {

          var position,
          $current = $results.eq(currentIndex);
          $results.removeClass(currentClass);

          if ($current.length) {
            $current.addClass(currentClass);
            position = $current.offset().top - offsetTop;
            $('html, body').animate({
                      scrollTop: position,
                  }, 100);
            // window.scrollTo(100, position);

            /*Abre aba para mostrar o conteudo marcado*/
            if($current.closest('.collapse').length){
              var header = $current.closest('.collapse').prev().attr('id');

              var botao = $('#'+header).find('button');

              if(botao.hasClass('collapsed')){
                botao.trigger('click');

                /* corre para o conteudo após abrir a aba*/
                setTimeout(function() {
                  $current = $results.eq(currentIndex);
                  position = $current.offset().top - offsetTop;
                  // window.scrollTo(200, position);
                  $('html, body').animate({
                      scrollTop: position,
                  }, 100);
                  // console.log('passou aqui');
                }, 500);
              }
            }
          }
        }
      }


      /* Searches for the entered keyword in the specified context on input */
      $input.on('input', function() {
        var searchVal = this.value;
        var resultadoText;

        $content.unmark({
          done: function() {
            $content.mark(searchVal, {
              separateWordSearch: true,
              done: function() {
                $results = $content.find('mark');
                // console.log($results.length);
                currentIndex = 0;
                jumpTo();
                if($results.length) {
                  if($results.length > 1){
                    resultadoText = 'resultados encontrados.'
                  }else {
                    resultadoText = 'resultado encontrado.'
                  }
                  $('.resultadoPesquisa').html($results.length+' '+resultadoText);
                }else {
                  if(searchVal.length) {
                    $('.resultadoPesquisa').html('nada foi encontrado com este termo');
                  }else {
                    $('.resultadoPesquisa').html('');
                  }
                }
              },
            });
          },
        });
      });

      /* Clears the search */
      $clearBtn.on('click', function() {
        $content.unmark();
        $input.val('').focus();
      });

      /* Next and previous search jump to */
      $nextBtn.add($prevBtn).on('click', function() {
        if ($results.length) {
          currentIndex += $(this).is($prevBtn) ? -1 : 1;
          if (currentIndex < 0) {
            currentIndex = $results.length - 1;
          }
          if (currentIndex > $results.length - 1) {
            currentIndex = 0;
          }
          jumpTo();
        }
      });

      //Pressionar enter para encontar
      $input.keypress(function(event){
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if(keycode == '13'){
          if ($results.length) {
            currentIndex += 1;
            if (currentIndex < 0) {
              currentIndex = $results.length - 1;
            }
            if (currentIndex > $results.length - 1) {
              currentIndex = 0;
            }
            jumpTo();
          }
        }
      });
    });

    /* verifica a posição da caixa de busca ao rolar a página */
    $(window).on('resize scroll', function() {
      if($results.length){
        // console.log('existe');
      }else {
        if($('.buscarPagina').length){
          if($('footer').isInViewport()) {
            $('.buscarPagina').removeClass('active');
          } else {
            $('.buscarPagina').addClass('active');
          }
        }
      }

      if($('.acesso-sticky').length){
        if($('#acesso-conteudo').isInViewport()) {
          $('.acesso-sticky').css({'bottom':'-180px'});
        } else {
          $('.acesso-sticky').css({'bottom':'0'});
        }
      }
    });



    /*
     * Verifica se teclado no mobile foi aberto e controla tamanho do viewport
     */

    function updateWindowSize() {
      window.lastInnerWidth = window.innerWidth;
      window.lastInnerHeight = window.innerHeight;
      window.lastOrientation = window.orientation;
      // Stays the same for iOS, so that's our ticket to detect iOS keyboard
      window.lastBodyHeight = document.body.clientHeight;
    }

    function detectKeyboard() {
      function orientationChange() {
        if ( ((window.lastOrientation == 0 || window.lastOrientation == 180) && (window.orientation == 0 || window.orientation == 180)) || ((window.lastOrientation == 90 || window.lastOrientation == -90) && (window.orientation == 90 || window.orientation == -90)) ) return false
        else return true;
      }
      var keyboardHeight;
      // No orientation change, keyboard opening
      if ( (window.lastInnerHeight - window.innerHeight > 150 ) && window.innerWidth == window.lastInnerWidth ) {
        keyboardHeight = window.lastInnerHeight - window.innerHeight;
        updateWindowSize();
        return keyboardHeight;
      }
      // Orientation change with keyboard already opened
      if ( orientationChange() && document.body.classList.contains('keyboard-open') ) {
        keyboardHeight = screen.height - window.topBarHeight - window.innerHeight;
        updateWindowSize();
        return keyboardHeight;
      }

      // No orientation change, keyboard closing
      if ( (window.innerHeight - window.lastInnerHeight > 150 ) && window.innerWidth == window.lastInnerWidth) {
        keyboardHeight = -1;
        updateWindowSize();
        return keyboardHeight;

      }

      // Orientation change or regular resize, no keyboard action
      keyboardHeight = 0;
      updateWindowSize();
      return keyboardHeight;
    }

    function keyboardShift(keyboardHeight) {
      if (!document.body.classList.contains('keyboard-open')) document.body.classList.add('keyboard-open');
      document.body.setAttribute('style', 'height: calc(100% + ' + keyboardHeight + 'px);');
    }

    function removeKeyboardShift() {
      document.body.classList.remove('keyboard-open');
      document.body.removeAttribute('style');
    }

    // OnStart innit
    (function() {
      updateWindowSize();
      window.topBarHeight = screen.height - window.innerHeight;
      window.addEventListener('resize', resizeThrottler, false);

      var resizeTimeout;
      function resizeThrottler() {
        // ignore resize events as long as an actualResizeHandler execution is in the queue
        if ( !resizeTimeout ) {
          resizeTimeout = setTimeout(function() {
            resizeTimeout = null;
            actualResizeHandler();
          // The actualResizeHandler will execute at a rate of 15fps
          }, 66);
        }
      }

      function actualResizeHandler() {
        var keyboardHeight = detectKeyboard();
        if (keyboardHeight > 0) { keyboardShift(keyboardHeight); }
        else if (keyboardHeight == -1) { removeKeyboardShift(); }
      }
    }());

    $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    $.fn.searchBox = function(ev) {
      var $searchEl = $('.search-elem');
      // var $placeHolder = $('.placeholder');
      var $sField = $('#search-field');
      // var moveText = function(){
      //   $placeHolder.addClass('move-up').html('searching...');
      // }

      // $sField.keydown(moveText);
      // $placeHolder.on('click', moveText);

      if ( ev === 'open') {
        $searchEl.addClass('search-open')
        $sField.focus();
      }

      if ( ev === 'close') {
        $searchEl.removeClass('search-open'),
        // $placeHolder.removeClass('move-up').html('Type something...'),
        $sField.val('');
      }

      // $('.submit').prop('disabled', true);
      // $('#search-field').keyup(function() {
      //   if($(this).val() != '') {
      //     $('.submit').prop('disabled', false);
      //   }
      // });
    }

    $('.buscar').on('click', function(e){
      $(this).searchBox('open');
      e.preventDefault();
    });

    $('.fechar').on('click', function(){
      $(this).searchBox('close');
    });

  },
};

/*
<div class="form-row" id="passo-1">
  <div class="col-12 mb-3">
    <label for="name">Qual o seu nome?</label>
    [text* name id:name class:form-control]
  </div>
  <div class="col-12 mb-3">
    <label for="email">Qual o seu e-mail?</label>
    [email* email id:email class:form-control]
  </div>
  <div class="col-12 mb-2">
     <label for="empresaForm">Você é dono(a) de um negócio/empresa?</label>
     [select* class:custom-select id:empresaForm first_as_label "Selecione" "Sim" "Não"]
  </div>
  <div class="col-12 mb-3">
     [checkbox rd-checkbox_field-k8gaizu6 use_label_element "Gostaria de receber conteúdos exclusivos da Endeavor por e-mail"]
  </div>

  <div class="col-12 mb-3 text-center">
    <a href="#" class="passo btn btn-success">próximo passo</a>
  </div>
</div>

<div class="form-row d-none" id="passo-2">
  <div class="col-12 mb-3">
    <label class="d-block">Entre 2018 e 2019, o seu faturamento cresceu:</label>
    [radio custom_fields_965325 use_label_element class:faturamento "Não cresceu ou decresceu" "Entre 1 e 19%" "Entre 20 e 40%" "Entre 41 e 60%" "Mais que 60%"]
  </div>
  <div class="col-12 mb-3">
    [submit class:btn class:btn-primary "Enviar"]
  </div>
</div>

<div class="form-row d-none" id="passo-3">
  <div class="col-12 mb-3">
  <label for="empresaForm" class="d-block">No momento:</label>
    [radio 'custom_fields_965326' use_label_element class:momento "Trabalho na área financeira de uma empresa" "Sou investidor" "Consultor/Escritório de advocacia/contabilidade" "Outros"]
  </div>
  <div class="col-12 mb-3">
    [submit class:btn class:btn-primary "Enviar"]
  </div>
</div>


<div class="form-row" id="passo-2">
  <div class="col-12 mb-3">
    <label class="d-block">Entre 2018 e 2019, o seu faturamento cresceu:</label>
    <span class="wpcf7-form-control-wrap custom_fields_965325"><span class="wpcf7-form-control wpcf7-radio faturamento required"><span class="wpcf7-list-item first"><label class="custom-control custom-radio"><input type="radio" name="custom_fields[965325]" value="Não cresceu ou decresceu" class="custom-control-input"><span class="wpcf7-list-item-label custom-control-label">Não cresceu ou decresceu</span></label></span><span class="wpcf7-list-item"><label class="custom-control custom-radio"><input type="radio" name="custom_fields[965325]" value="Entre 1 e 19%" class="custom-control-input"><span class="wpcf7-list-item-label custom-control-label">Entre 1 e 19%</span></label></span><span class="wpcf7-list-item"><label class="custom-control custom-radio"><input type="radio" name="custom_fields[965325]" value="Entre 20 e 40%" class="custom-control-input"><span class="wpcf7-list-item-label custom-control-label">Entre 20 e 40%</span></label></span><span class="wpcf7-list-item"><label class="custom-control custom-radio"><input type="radio" name="custom_fields[965325]" value="Entre 41 e 60%" class="custom-control-input"><span class="wpcf7-list-item-label custom-control-label">Entre 41 e 60%</span></label></span><span class="wpcf7-list-item last"><label class="custom-control custom-radio"><input type="radio" name="custom_fields[965325]" value="Mais que 60%" class="custom-control-input"><span class="wpcf7-list-item-label custom-control-label">Mais que 60%</span></label></span></span></span>
  </div>
  <div class="col-12 mb-3">
    <input type="submit" value="Enviar" class="wpcf7-form-control wpcf7-submit btn btn-primary"><span class="ajax-loader"></span>
  </div>
</div>


<div class="col-12 mb-2">
     <label for="empresaForm">Você é dono(a) de um negócio/empresa?</label>
     <span class="wpcf7-form-control-wrap"><select name="custom_fields[472744]" class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required custom-select" id="empresaForm" aria-required="true" aria-invalid="false" required="required"><option value="">Selecione</option><option value="Sim">Sim</option><option value="Não">Não</option></select></span>
  </div>

  <div class="col-12 mb-3">
     <span class="wpcf7-form-control-wrap"><span class="wpcf7-form-control wpcf7-checkbox"><span class="wpcf7-list-item first last"><label class="custom-control custom-checkbox"><input type="checkbox" name="custom_fields[15491]" value="1" class="custom-control-input"><span class="wpcf7-list-item-label custom-control-label">Gostaria de receber conteúdos exclusivos da Endeavor por e-mail</span></label></span></span></span>
  </div>

  <div class="col-12 mb-3">
  <label for="empresaForm" class="d-block">No momento:</label>
    <span class="wpcf7-form-control-wrap"><span class="wpcf7-form-control wpcf7-radio momento"><span class="wpcf7-list-item first"><label class="custom-control custom-radio"><input type="radio" name="custom_fields[965326]" value="Trabalho na área financeira de uma empresa" class="custom-control-input"><span class="wpcf7-list-item-label custom-control-label">Trabalho na área financeira de uma empresa</span></label></span><span class="wpcf7-list-item"><label class="custom-control custom-radio"><input type="radio" name="custom_fields[965326]" value="Sou investidor" class="custom-control-input"><span class="wpcf7-list-item-label custom-control-label">Sou investidor</span></label></span><span class="wpcf7-list-item"><label class="custom-control custom-radio"><input type="radio" name="custom_fields[965326]" value="Consultor/Escritório de advocacia/contabilidade" class="custom-control-input"><span class="wpcf7-list-item-label custom-control-label">Consultor/Escritório de advocacia/contabilidade</span></label></span><span class="wpcf7-list-item last"><label class="custom-control custom-radio"><input type="radio" name="custom_fields[965326]" value="Outros" class="custom-control-input"><span class="wpcf7-list-item-label custom-control-label">Outros</span></label></span></span></span>
  </div>
*/





// WEBPACK FOOTER //
// ./scripts/routes/common.js